import * as React from "react";
import {css, cx} from "emotion";
import {rgba} from "polished";

import "./footer.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {isDevQuan}      from "@Common/ui-components/debug/is-dev-quan";

import {formatEmail} from "../../common/components/email/format-email";

import {FscLogo}             from "./fsc-logo-svg";
import {PrivacyPolicyModal}  from "./privacy-policy-modal/privacy-policy-modal";
import {SecurityMetricsLogo} from "./security-metrics-logo-svg";

export const LayoutFooter = ({navBlock=undefined}) => cs(
    consumeContext("themeScheme"),
    consumeContext("menus"),
    ["privacyPolicyModal", (_, next) => PrivacyPolicyModal({next})],
    ({themeScheme, menus, privacyPolicyModal}) => (
        <div {...{
            // -zzz to avoid conflict with PHP page
            className: cx("footer-2w7 footer-zzz", css`
                & > .item-ov1 {
                    color: ${themeScheme.xpresso.menuTextColor} !important;
                    
                    &.link-ov1 {
                        &:hover {
                          color: ${rgba(themeScheme.xpresso.menuTextColor, 0.9)} !important;
                        }
                    }
                }
            `/*, css`
                //All font changes will be handled in the body unless we want to use different fonts in the header or footer
                font-family: Lato, "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
                font-weight: 400;
            `*/),
            style: {background: themeScheme.xpresso.menuBackgroundColor},

            "xd-qa-type": "card",
            "xd-qa-name": "Layout Footer",
        }}>
            <a
                href="https://www.securitymetrics.com/" className="item-ov1 link-ov1" target="_blank"
            >
                {!isDevQuan() && (
                    <SecurityMetricsLogo
                        className="item-ov1 link-ov1 security-metrics-logo"
                        fill={themeScheme.xpresso.menuTextColor}
                        xd-qa-type="logo"
                        xd-qa-name="security_metrics"
                    />
                )}
            </a>
            <a
                href="https://fsc.org/en" className="item-ov1 link-ov1 fsc-link" target="_blank"
            >
                <FscLogo className="item-ov1 link-ov1 fsc-logo" fill={themeScheme.xpresso.menuTextColor}/>
            </a>
            <div className="item-ov1 link-ov1" xd-qa-type="link" xd-qa-name="Privacy Policy" onClick={() => privacyPolicyModal.show()}>
                Privacy Policy
            </div>
            <div className="item-ov1 link-ov1">
                {(() => {
                    const telephone = menus?.helpMenu?.subMenu?.find((m) => m.type === "tel");

                    return telephone && (
                        <a
                            className={cx("item-ov1",
                                css`
                                    color: ${themeScheme.xpresso.menuTextColor} !important;
                                    text-decoration: none;
                                    &:hover {
                                        color: white;
                                    }
                                `
                            )}
                            href={telephone.link}
                            xd-qa-type="link"
                            xd-qa-name={telephone.linkLabel}

                            onClick={async (e) => {
                                e.preventDefault();
                                if (await navBlock?.block() === true) {
                                    return;
                                }
                                window.location.href = telephone.link;
                            }}
                        >
                            {telephone.linkLabel}
                        </a>
                    );
                })()}
            </div>
            <div className="item-ov1 link-ov1">
                {(() => {
                    const email = themeScheme?.helpMenu ? (
                        themeScheme?.helpMenu?.subMenu?.find((m) => m.type === "email")
                    ) : (
                        menus?.helpMenu?.subMenu?.find((m) => m.type === "email")
                    );

                    return email && (
                        <a
                            className={cx(
                                "item-ov1",
                                css`
                                    color: ${themeScheme.xpresso.menuTextColor} !important;
                                    text-decoration: none;
                                    &:hover {
                                        color: white;
                                    }
                                `
                            )}
                            href={email.link}
                            onClick={async (e) => {
                                e.preventDefault();
                                if (await navBlock?.block() === true) {
                                    return;
                                }
                                window.location.href = email.link;
                            }}
                            xd-qa-type="link"
                            xd-qa-name="Email"
                        >
                            {formatEmail(email.linkLabel)}
                        </a>
                    );
                })()}
            </div>
            <div {...{
                className: "item-ov1",

                "xd-qa-type": "label",
                "xd-qa-name": "Copyright",
            }}>
                Copyright Xpressdocs © {new Date().getFullYear()}
            </div>
        </div>
    ),
);